(() => {
  if (window.vcCompareReady) return;
  const root = document.querySelector('[data-vc-compare-root]');
  if (!root) return;
  window.vcCompareReady = true;
  const translations = JSON.parse(root.querySelector('[data-vc-compare-translations]').textContent);
  const t = (key, values = {}) => Object.entries(values).reduce((text, [name, value]) => text.replaceAll(`{${name}}`, String(value)), translations[key] || key);
  const storeKey = 'vc-vanity-comparison-v1';
  const catalog = new Map();
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,180}$/.test(value);
  const cleanSelection = data => Array.isArray(data) ? [...new Set(data.filter(validHandle))].slice(0, 3) : [];
  let selected = [];
  try { selected = cleanSelection(JSON.parse(localStorage.getItem(storeKey) || '[]')); } catch (_) {}
  const dialog = root.querySelector('[data-vc-compare-dialog]');
  const tray = root.querySelector('[data-vc-compare-tray]');
  const status = root.querySelector('[data-vc-compare-status]');
  const tableWrap = root.querySelector('[data-vc-compare-table]');
  const difference = root.querySelector('[data-vc-compare-differences]');
  let statusTimer;
  let returnFocus;
  let previousOverflow = '';
  let requestVersion = 0;
  const node = (tag, className, text) => {
    const el = document.createElement(tag);
    if (className) el.className = className;
    if (text !== undefined) el.textContent = text;
    return el;
  };
  const validProduct = item => item && validHandle(item.handle) && typeof item.title === 'string' && Array.isArray(item.options);
  const readData = scope => {
    scope.querySelectorAll('[data-vc-compare-data]').forEach(script => {
      try {
        const data = JSON.parse(script.textContent);
        if (validProduct(data)) catalog.set(data.handle, data);
      } catch (_) {}
    });
  };
  const announce = message => {
    clearTimeout(statusTimer);
    status.textContent = message;
    statusTimer = setTimeout(() => { status.textContent = ''; }, 5500);
  };
  const persist = () => { try { localStorage.setItem(storeKey, JSON.stringify(selected)); } catch (_) {} };
  const image = (data, className) => {
    if (!data?.image) return null;
    const url = new URL(data.image, location.origin);
    if (url.protocol !== 'https:') return null;
    const img = node('img', className);
    img.src = url.href;
    img.alt = data.title;
    img.width = 300;
    img.height = 200;
    img.loading = 'lazy';
    return img;
  };
  const productUrl = handle => new URL(root.dataset.productsRoot + encodeURIComponent(handle), location.origin);
  const removeButton = (handle, label) => {
    const btn = node('button', 'vc-compare-remove', label);
    btn.type = 'button';
    btn.dataset.vcCompareRemove = handle;
    btn.setAttribute('aria-label', t('actions.remove_named', { title: catalog.get(handle)?.title || handle }));
    return btn;
  };
  const sync = () => {
    document.querySelectorAll('[data-vc-compare-add]').forEach(btn => {
      btn.hidden = false;
      const added = selected.includes(btn.dataset.vcCompareAdd);
      btn.setAttribute('aria-pressed', String(added));
      btn.querySelector('[data-vc-compare-button-label]').textContent = t(added ? 'actions.added' : 'actions.add');
      btn.setAttribute('aria-label', t(added ? 'actions.remove_named' : 'actions.add_named', { title: catalog.get(btn.dataset.vcCompareAdd)?.title || btn.dataset.vcCompareAdd }));
    });
    tray.hidden = selected.length === 0;
    root.querySelector('[data-vc-compare-count]').textContent = selected.length < 2 ? t('labels.need_two') : t('labels.selected', { count: selected.length });
    const open = root.querySelector('[data-vc-compare-open]');
    open.disabled = selected.length < 2;
    open.textContent = t('actions.compare') + ` (${selected.length})`;
    const thumbs = root.querySelector('[data-vc-compare-thumbs]');
    thumbs.replaceChildren();
    selected.forEach(handle => {
      const wrapper = node('div', 'vc-compare-thumb');
      const img = image(catalog.get(handle));
      if (img) wrapper.append(img);
      wrapper.append(removeButton(handle, '×'));
      thumbs.append(wrapper);
    });
  };
  const options = (data, names) => data.options.filter(option => names.includes(option.name.trim().toLowerCase())).flatMap(option => option.values).filter(value => value && value !== 'Default Title');
  const optionText = (data, names, fallback = '') => [...new Set(options(data, names))].join(', ') || fallback;
  const rows = [
    ['price', data => `${data.priceVaries ? t('labels.from') + ' ' : ''}${data.price}`],
    ['width', data => data.width], ['depth', data => data.depth], ['height', data => data.height],
    ['installation', data => data.installation], ['material', data => data.material],
    ['colour', data => optionText(data, ['cabinet colour', 'cabinet color', 'colour', 'color', 'finish', 'cabinet finish'], data.colour)],
    ['top_material', data => data.topMaterial],
    ['top_colour', data => optionText(data, ['countertop colour', 'countertop color', 'countertop', 'top colour', 'top color'], data.topColour)],
    ['package', data => optionText(data, ['package', 'configuration', 'countertop options', 'countertop option', 'top options'])],
    ['hardware', data => optionText(data, ['handle colour', 'handle color', 'hardware colour', 'hardware color', 'legs colour', 'legs color'])],
    ['sink', data => data.sink], ['storage', data => data.storage],
    ['availability', data => t(data.available ? 'labels.available' : 'labels.unavailable')]
  ];
  const applyDifferences = () => {
    let visible = 0;
    tableWrap.querySelectorAll('[data-vc-same]').forEach(row => {
      row.hidden = difference.checked && row.dataset.vcSame === 'true';
      if (!row.hidden) visible++;
    });
    const caption = tableWrap.querySelector('caption');
    if (caption) caption.hidden = !difference.checked || visible > 0;
  };
  const render = () => {
    tableWrap.replaceChildren();
    if (!selected.length) { tableWrap.append(node('p', 'vc-compare-empty', t('labels.no_selection'))); return; }
    const table = node('table', 'vc-compare-table');
    table.setAttribute('aria-label', t('labels.title'));
    table.style.setProperty('--vc-compare-count', selected.length);
    table.style.minWidth = `${150 + selected.length * 245}px`;
    const cols = node('colgroup');
    const labelCol = node('col'); labelCol.style.width = '150px'; cols.append(labelCol);
    selected.forEach(() => cols.append(node('col'))); table.append(cols);
    const head = node('thead'); const headingRow = node('tr');
    const corner = node('th', '', t('labels.product')); corner.scope = 'col'; headingRow.append(corner);
    selected.forEach(handle => {
      const data = catalog.get(handle);
      const th = node('th'); th.scope = 'col';
      if (data) {
        const img = image(data, 'vc-compare-product-image'); if (img) th.append(img);
        const title = node('a', 'vc-compare-product-title', data.title); title.href = productUrl(handle); th.append(title);
        const details = node('a', 'vc-compare-details', t('actions.details')); details.href = productUrl(handle); th.append(details);
      } else th.append(node('p', '', t('labels.failed')));
      th.append(removeButton(handle, t('actions.remove'))); headingRow.append(th);
    });
    head.append(headingRow); table.append(head);
    const body = node('tbody');
    rows.forEach(([key, get]) => {
      const values = selected.map(handle => catalog.has(handle) ? String(get(catalog.get(handle)) || '').trim() : '');
      if (['package', 'hardware'].includes(key) && values.every(value => !value)) return;
      const row = node('tr'); row.dataset.vcSame = String(values.every(value => value.toLowerCase() === values[0].toLowerCase()));
      const label = node('th', '', t('labels.' + key)); label.scope = 'row'; row.append(label);
      values.forEach((value, index) => {
        const td = node('td');
        td.append(node('span', !value ? 'vc-compare-missing' : key === 'price' ? 'vc-compare-price' : '', value || t('labels.missing')));
        if (key === 'price' && catalog.get(selected[index])?.priceVaries) td.append(node('span', 'vc-compare-price-note', t('labels.price_note')));
        row.append(td);
      });
      body.append(row);
    });
    table.append(body);
    const caption = node('caption', '', t('labels.same')); caption.hidden = true; table.append(caption);
    tableWrap.append(table); applyDifferences();
  };
  const fetchProduct = async handle => {
    const url = productUrl(handle);
    url.searchParams.set('section_id', root.dataset.sectionId);
    const response = await fetch(url, { credentials: 'same-origin', signal: AbortSignal.timeout(12000) });
    if (!response.ok) throw new Error('Unavailable');
    const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
    const script = parsed.querySelector('[data-vc-compare-data]');
    const data = JSON.parse(script?.textContent || 'null');
    if (!validProduct(data) || data.handle !== handle) throw new Error('Unavailable');
    catalog.set(handle, data);
  };
  const refresh = async () => {
    const version = ++requestVersion;
    const loading = root.querySelector('[data-vc-compare-loading]');
    loading.textContent = t('labels.loading');
    const handles = [...selected];
    const results = await Promise.allSettled(handles.map(fetchProduct));
    if (version !== requestVersion) return;
    results.forEach((result, index) => { if (result.status === 'rejected') catalog.delete(handles[index]); });
    loading.textContent = results.some(result => result.status === 'rejected') ? t('labels.failed') : '';
    sync(); if (dialog.open) render();
  };
  const remove = handle => {
    selected = selected.filter(value => value !== handle); persist(); sync();
    if (dialog.open) render(); announce(t('labels.removed'));
  };
  document.addEventListener('click', event => {
    const add = event.target.closest('[data-vc-compare-add]');
    if (add) {
      event.preventDefault(); event.stopPropagation();
      const handle = add.dataset.vcCompareAdd;
      if (selected.includes(handle)) { remove(handle); return; }
      if (selected.length === 3) { announce(t('labels.maximum')); return; }
      readData(document); selected.push(handle); persist(); sync(); announce(t('labels.added'));
      return;
    }
    const removeTarget = event.target.closest('[data-vc-compare-remove]');
    if (removeTarget) { remove(removeTarget.dataset.vcCompareRemove); return; }
    if (event.target.closest('[data-vc-compare-clear]')) { selected = []; persist(); sync(); announce(t('labels.cleared')); return; }
    if (event.target.closest('[data-vc-compare-open]') && selected.length >= 2) {
      returnFocus = event.target; render(); previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden'; dialog.showModal(); refresh(); return;
    }
    if (event.target.closest('[data-vc-compare-close]')) dialog.close();
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow; if (returnFocus?.isConnected && !returnFocus.disabled) returnFocus.focus(); });
  difference.addEventListener('change', applyDifferences);
  window.addEventListener('storage', event => {
    if (event.key !== storeKey) return;
    try { selected = cleanSelection(JSON.parse(event.newValue || '[]')); } catch (_) { selected = []; }
    sync(); if (dialog.open) { render(); refresh(); }
  });
  let queued = false;
  new MutationObserver(records => {
    const addedProducts = records.some(record => [...record.addedNodes].some(el => el.nodeType === 1 && (el.matches('[data-vc-compare-entry]') || el.querySelector('[data-vc-compare-entry]'))));
    if (!addedProducts || queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; readData(document); sync(); });
  }).observe(document.body, { childList: true, subtree: true });
  readData(document); sync();
  if (selected.length) refresh();
})();
